import { round2 } from "./pricing"

// Total de una línea de carrito/orden retail. Por peso: precio/unidad × peso.
// Por unidad: (precio + modificadores) × cantidad. `weight != null` → es por peso.
export function retailLineTotal(args: {
  unitPrice: number
  modifiersTotal: number
  quantity: number
  weight: number | null
}): number {
  if (args.weight != null) {
    return round2(args.unitPrice * args.weight)
  }
  return round2((args.unitPrice + args.modifiersTotal) * args.quantity)
}
